import React, { useEffect, useState } from 'react';
import {
  Container,
  SelectedTab,
  SelectTabWrapper,
  Table,
  Title
} from './styled';

const PlayerSeasonStat = ({ data }) => {
  const [list, setList] = useState([]);
  let selectedTeam, setSelectedTeam;
  [selectedTeam, setSelectedTeam] = useState('home');
  useEffect(() => {
    setList(data[selectedTeam].additionalTeamData);
  }, [selectedTeam]);

  return (
    <Container>
      <Title>개인 시즌 성적</Title>
      <SelectTabWrapper>
        <SelectedTab
          isSelected={selectedTeam === 'home'}
          onClick={() => setSelectedTeam('home')}
        >
          {data.home.name}
        </SelectedTab>
        <SelectedTab
          isSelected={selectedTeam === 'away'}
          onClick={() => setSelectedTeam('away')}
        >
          {data.away.name}
        </SelectedTab>
      </SelectTabWrapper>

      <Table>
        <colgroup>
          <col width={150} />
          <col width={70} />
          <col width={70} />
          <col width={70} />
          <col width={70} />
          <col width={70} />
          <col width={70} />
          <col width={70} />
        </colgroup>
        <thead>
          <tr>
            <th>선수명</th>
            <th>출장시간</th>
            <th>득점</th>
            <th>어시스트</th>
            <th>리바운드</th>
            <th>스틸</th>
            <th>블록</th>
            <th>턴오버</th>
          </tr>
        </thead>
        <tbody>
          {list.length > 0 &&
            list.map((value, key) => {
              const {
                timesPlayedAverage,
                points,
                assists,
                reboundsTotal,
                steals,
                blockedShots,
                turnovers
              } = value;
              return (
                <tr key={key}>
                  <td>{value.player.displayName}</td>
                  <td>{timesPlayedAverage}</td>
                  <td>{points}</td>
                  <td>{assists}</td>
                  <td>{reboundsTotal}</td>
                  <td>{steals}</td>
                  <td>{blockedShots}</td>
                  <td>{turnovers}</td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </Container>
  );
};

export default PlayerSeasonStat;
